export function isAndroidWebView(): boolean {
  return typeof window !== 'undefined' && !!(window as any).NativeBridge;
} 

// Helper to generate a random UID
export const generateUID = (): string => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  // Fallback for environments without crypto.randomUUID
  return Math.random().toString(36).substr(2, 9) + Date.now();
};